export default class NCM {
  constructor(id, codigo, descricao, dataInicio, dataFim) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
    this.dataInicio = dataInicio
    this.dataFim = dataFim
  }
}
